import Http from "@/Http/Request";
import { useQuery } from "react-query";
import { GetModuleByIdResponse } from "./types";

const getModuleById = async (id: number) => {
	const { data } = await Http({
		method: 'GET',
		url: 'getModuleByIdApi',
		params: {
			id
		}

	});
	return data;
}

const useDetailModule = (id: number, enabled: boolean) => {
	const { data: response, isLoading, error, refetch } = useQuery<GetModuleByIdResponse, Error>({
		queryKey: ['moduleDetail', {id}],
		queryFn: () => getModuleById(id),
		keepPreviousData: true,
		enabled
	});
	const data = response?.data || {} as GetModuleByIdResponse['data']
	
	const result: GetModuleByIdResponse = {
		data,
		message: response?.message || '',
		status: response?.status || 0
		
	};
	
	return { data: result, isLoading, error, refetch };

}

export default useDetailModule